package com.sddamico.swigmore.ds.feedback

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.brand.Crest
import com.sddamico.swigmore.ds.brand.CrestVariant
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeBody
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** A lock-screen notification mock, as on the announcement preview. */
@Composable
fun PushPreview(title: String, body: String, at: String, modifier: Modifier = Modifier) {
  Div(
    attrs = Modifier.css("background" to "rgba(239,229,201,.14)", "border-radius" to "16px", "padding" to "11px 12px",
      "display" to "grid", "grid-template-columns" to "34px minmax(0,1fr)", "gap" to "10px", "color" to SwColor.cream)
      .then(modifier).toAttrs()
  ) {
    Crest(variant = CrestVariant.Gold, size = 34)
    Div {
      Div(attrs = Modifier.typeBody("12px", 600, "normal").css("display" to "flex", "justify-content" to "space-between").toAttrs()) {
        Span { Text("Swigmore Poll") }
        Span(attrs = Modifier.css("opacity" to ".6", "font-weight" to "400").toAttrs()) { Text(at) }
      }
      Div(attrs = Modifier.typeBody("13px", 600, "1.3").css("margin-top" to "2px").toAttrs()) { Text(title) }
      Div(attrs = Modifier.typeBody("13px", 400, "1.35").css("opacity" to ".8", "margin-top" to "2px").toAttrs()) { Text(body) }
    }
  }
}
